<style lang="scss" scoped>
    .tissue-view {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;

        @include above(md) {
            flex-wrap: nowrap;
        }

        &__species {
            flex: 1 0 100%;

            @include above(md) {
                flex: 1 0 45%;
                transform: translateY(-20%);
            }
        }

        &__back {
            display: block;
            margin-bottom: 25px;

            @include above(md) {
                display: none;
            }
        }

        &__tissue-web {
            flex: 1 1 auto;
            &-container {
                position: absolute;
                top: 0;
                left: 10%;
                right: 0;
                bottom: 0;
                width: 90%;
                height: 100%;
                display: none;

                @include above(md) {
                    display: flex;
                }
            }
        }

        &__tissue-grid {
            @include _fg(3, 25, 0);

            @include above(md) {
                display: none;
            }

            &-item {
                margin-bottom: 25px;

                @include last-grid-row(3) {
                    margin-bottom: 0;
                }

                &-image,
                &-label {
                    display: block;
                }

                &-image {
                    background-color: $black;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: contain;
                    border-radius: 100%;
                    border: 2px solid $white;
                    margin-bottom: 10px;
                    img {
                        display: block;
                        width: 100%;
                        height: auto;
                    }
                }
                &-label {
                    text-align: center;
                    text-transform: uppercase;
                }
            }
        }
    }
</style>
<template>
    <div class="tissue-view" v-if="progressData.length && species && progress">
        <router-link class="tissue-view__back" :to="{name: 'SpeciesView'}">&lt; Back</router-link>
        <div class="tissue-view__tissue-web-container">
            <tissue-web class="tissue-view__tissue-web" @tissue-click="handleClick" :tissues="species.tissues" />
        </div>
        <div class="tissue-view__tissue-grid">
            <a
                href="#!"
                v-for="(tissue, i) in species.tissues"
                :key="`${tissue.key}-${i}`"
                @click.prevent="handleClick(tissue.key)"
                class="tissue-view__tissue-grid-item"

            >
                <span class="tissue-view__tissue-grid-item-image" :style="{backgroundImage: `url(${tissue.images.thumb})`}">
                    <img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="aspect ratio pixel" />
                </span>
                <span class="tissue-view__tissue-grid-item-label">{{ tissue.name }}</span>
            </a>
        </div>
    </div>
</template>

<script>
import Species from '@/components/Species'
import Loading from '@/components/Loading'
import TitleMixin from '@/mixins/title-mixin'
import { mapState, mapMutations } from 'vuex'
const TissueWeb = () => ({
    loading: Loading,
    component: import(/* webpackChunkName 'TissueWeb' */ '@/components/TissueWeb'),
})

export default {
    mixins: [TitleMixin],
    name: 'TissueView',
    computed: {
        key() {
            return this.$route.params.species
        },
        ...mapState({
            species(state) {
                return state.species ?
                    state.species.reduce((sum, species) => this.key === species.key ? species : sum, null) :
                    null
            },
            progress: 'progress',
            progressData: 'progressData',
        }),
    },
    title() {
        return this.species ? this.species.name : null
    },
    methods: {
        handleClick(tissue) {
            tissue = this.species.tissues.reduce((sum, t) => t.key === tissue ? t : sum, null)
            if (tissue.phenotypes) {
                this.$router.push({name: 'PhenotypeView', params: {species: this.key, tissue: tissue.key}})
            } else {
                this.setCrowdsourceActive(true)
            }
        },
        ...mapMutations([
            'setCrowdsourceActive',
            'setNeonTitle',
            'setProgressLinks',
            'setProgressTitles',
        ]),
    },
    mounted() {
        if (this.species) {
            this.setProgressTitles([
                this.species.name,
            ])
            this.setProgressLinks([
                {name: 'SpeciesView'},
            ])
            this.setNeonTitle(this.species.name)
        }
    },
    updated() {
        if (this.species) {
            this.setProgressTitles([
                this.species.name,
            ])
            this.setProgressLinks([
                {name: 'SpeciesView'},
            ])
            this.setNeonTitle(this.species.name)
        }
    },
    components: {
        Species,
        TissueWeb,
    },
}
</script>
